export const flags = {
  BR: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 480">
    <path fill="#009c3b" d="M0 0h640v480H0z"/>
    <path fill="#ffdf00" d="M320 0l320 240-320 240L0 240z"/>
    <g fill="#002776">
      <circle cx="320" cy="240" r="120"/>
    </g>
  </svg>`,
  PT: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 480">
    <path fill="#f00" d="M0 0h640v480H0z"/>
    <path fill="#060" d="M0 0h320v480H0z"/>
    <circle cx="160" cy="240" r="80" fill="#ff0"/>
    <circle cx="160" cy="240" r="70" fill="#fff"/>
    <circle cx="160" cy="240" r="60" fill="#f00"/>
    <path fill="#ff0" d="M160 240l-40-40h80z"/>
  </svg>`,
  US: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 480">
    <path fill="#bd3d44" d="M0 0h640v480H0z"/>
    <path stroke="#fff" stroke-width="37" d="M0 55.3h640M0 129h640M0 203h640M0 277h640M0 351h640M0 425h640"/>
    <path fill="#192f5d" d="M0 0h364.8v258.5H0z"/>
    <g fill="#fff">
      <g id="d">
        <g id="c">
          <g id="e">
            <g id="b">
              <path id="a" d="M24.8 25l3.2 9.8h10.4l-8.4 6.1 3.2 9.8-8.4-6.1-8.4 6.1 3.2-9.8-8.4-6.1h10.4z"/>
              <use href="#a" y="19.6"/>
            </g>
            <use href="#b" y="39.2"/>
          </g>
          <use href="#e" y="78.4"/>
        </g>
        <use href="#c" y="156.8"/>
      </g>
      <use href="#d" x="78.4"/>
    </g>
  </svg>`,
  GB: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 480">
    <path fill="#012169" d="M0 0h640v480H0z"/>
    <path stroke="#fff" stroke-width="40" d="M0 0l640 480m0-480L0 480"/>
    <path stroke="#C8102E" stroke-width="27" d="M0 0l640 480m0-480L0 480"/>
    <path stroke="#fff" stroke-width="40" d="M320 0v480M0 240h640"/>
    <path stroke="#C8102E" stroke-width="27" d="M320 0v480M0 240h640"/>
  </svg>`,
  FR: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 480">
    <path fill="#ED2939" d="M0 0h640v480H0z"/>
    <path fill="#fff" d="M0 0h426.7v480H0z"/>
    <path fill="#002395" d="M0 0h213.3v480H0z"/>
  </svg>`,
  IT: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 480">
    <path fill="#009246" d="M0 0h213.3v480H0z"/>
    <path fill="#fff" d="M213.3 0h213.4v480H213.3z"/>
    <path fill="#ce2b37" d="M426.7 0H640v480H426.7z"/>
  </svg>`,
  ES: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 480">
    <path fill="#c60b1e" d="M0 0h640v480H0z"/>
    <path fill="#ffc400" d="M0 120h640v240H0z"/>
  </svg>`,
  DE: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 480">
    <path fill="#000" d="M0 0h640v160H0z"/>
    <path fill="#dd0000" d="M0 160h640v160H0z"/>
    <path fill="#ffce00" d="M0 320h640v160H0z"/>
  </svg>`,
  NL: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 480">
    <path fill="#AE1C28" d="M0 0h640v480H0z"/>
    <path fill="#fff" d="M0 0h640v320H0z"/>
    <path fill="#21468B" d="M0 0h640v160H0z"/>
  </svg>`
}; 